module.exports = __webpack_public_path__ + "static/media/B45892_LAT.b0922ec9.pdf";